var _path, _rect, _path2, _path3, _circle, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIndoorArt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 42 42",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m21.166,35.849c-3.008,0-4.137-1.484-7.03-1.484s-7.122,2.226-9.05,1.484c-1.929-.742-2.522-2.374-1.78-4.006s1.409-3.264,1.409-4.748-1.719-3.42-1.719-6.095,1.719-4.611,1.719-6.095-.668-3.116-1.409-4.748-.148-3.264,1.78-4.006,6.157,1.484,9.05,1.484,3.827-1.484,7.03-1.484,3.806,1.484,6.699,1.484,7.122-2.226,9.05-1.484,2.522,2.374,1.78,4.006-1.409,3.264-1.409,4.748c0,1.484,1.719,3.42,1.719,6.095,0,2.675-1.719,4.611-1.719,6.095,0,1.484.668,3.116,1.409,4.748s.148,3.264-1.78,4.006-6.157-1.484-9.05-1.484-3.692,1.484-6.699,1.484Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 8.319,
    y: 11.009,
    width: 25.363,
    height: 19.808
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m8.488,25.091c5.041-3.008,7.839-3.008,12.164,0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m8.488,26.783s2.703,3.259,7.32,2.068c4.616-1.191,8.842-9.544,11.6-9.544s3.565,4.408,6.106,6.531"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 17.083,
    cy: 17.162,
    r: 3.04
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m33.512,30.068s-4.757-4.006-6.699-4.006c-3.118,0-4.215,4.753-10.739,4.753"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIndoorArt);
export default __webpack_public_path__ + "static/media/indoor-art.3d5e75f48e7f3532502c8c12a2a1b5d0.svg";
export { ForwardRef as ReactComponent };